import { RateModelDto } from './ratemodeldto';
import { AcademicFeeTraductionDto } from './academicfeetraductiondto';

export class AcademicFeeDto {
    idOwnAcademicFee?: number;
    numberOfRegistration?: string;
    active?: string;
    rateModelDto?: RateModelDto;
    rateType?: string;

    ownAcademicFeeTraductionDto?: AcademicFeeTraductionDto[] = [];

    constructor(data?: Partial<AcademicFeeDto>) {
        Object.assign(this, data);
    }
}


